import init from './init'

window.addEventListener('DOMContentLoaded', () => {
    init(Vue, jQuery); // we depend on that vue and jquery will be loaded in the footer of the page.
});
